import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение данных калькулятора проекта
    async getCalculateProjects(data) {
      let params = this.makeSearchParams(data);
      params.set("start", data.start);
      params.set("end", data.end);

      return await this.get(`analytics/calculator?${params.toString()}${data.locations}${data.users}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/analytics.js